// -----------------------------------------------------------
// FloraIQ - Foto-base do exemplar arboreo
// -----------------------------------------------------------
// A foto e servida pela API com token (GET /trees/{id}/photo). Sem foto
// cadastrada, ou se o arquivo nao carregar, mostra a imagem padrao.

import { useEffect, useState } from "react";
import { campaignApi } from "@/lib/api";

export const TREE_PHOTO_PLACEHOLDER = "/images/sem-foto-exemplar.webp";

export interface TreeBasePhotoProps {
  treeId: number | null;
  alt: string;
  className?: string;
  /** Muda depois de um envio para recarregar a foto. */
  version?: number;
  /** Informa se o exemplar tem foto-base (para o rotulo "Registrar"/"Trocar"). */
  onStatus?: (hasPhoto: boolean) => void;
}

export default function TreeBasePhoto({
  treeId, alt, className = "w-full h-full object-cover", version = 0, onStatus,
}: TreeBasePhotoProps) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!treeId) return;
    let cancelled = false;
    let objectUrl: string | null = null;
    campaignApi
      .treePhotoMetadata(treeId)
      .then((meta) => {
        if (!cancelled) onStatus?.(meta.has_photo);
        return meta.has_photo ? campaignApi.treePhotoUrl(treeId) : null;
      })
      .then((u) => {
        if (cancelled) {
          if (u) URL.revokeObjectURL(u);
          return;
        }
        objectUrl = u;
        setUrl(u);
      })
      .catch(() => !cancelled && setUrl(null));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setUrl(null);
    };
    // onStatus fica fora das dependencias de proposito: um callback novo a cada
    // render refaria o download da foto.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeId, version]);

  if (url) return <img src={url} alt={alt} className={className} onError={() => setUrl(null)} />;
  return (
    <img
      src={TREE_PHOTO_PLACEHOLDER}
      alt="Sem foto disponível"
      className={className.replace("object-cover", "object-contain")}
    />
  );
}
